import { render, staticRenderFns } from "./AnalyticalDashboard.vue?vue&type=template&id=298fe9b4"
import script from "./AnalyticalDashboard.vue?vue&type=script&lang=js"
export * from "./AnalyticalDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports